import {Component} from '@angular/core';

@Component({
    selector: 'af-transaction-droppers-tab',
    templateUrl: 'incident-transaction-droppers-tab.component.html',
    standalone: false
})
export class IncidentTransactionDroppersTabComponent {

}
